import { Divider } from '@material-ui/core'
import React from 'react'
import { useTranslate } from 'react-redux-multilingual/lib/context'
import { AppWrapper } from '../../containers'

function Status() {
	const t = useTranslate()

	return (
		<AppWrapper
			showBackIcon={false}
			observeBackHistory={true}
			showLangIcon={false}
			showCartIcon={false}
			showAccountDropdown={false}
			showFooter={false}
		>
			<div className="statusContainer">
				<div className="inProgress">
					<h2>{t('STATUS.IN_PROGRESS')}</h2>
				</div>
				<Divider className="inProgressDivider" />
				<div className="inProgressText">{t('STATUS.IN_PROGRESS_TEXT')}</div>
			</div>
		</AppWrapper>
	)
}

export default Status
